module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/access_main-visual_bg-ddfe3d30a53731ba49f883f20971e91b.png";